const IrrigationContent = [
  {
    title: "Introduction",
    description: `
      Agriculture remains the backbone of rural livelihoods, but productivity is often constrained by unreliable rainfall, 
      inefficient irrigation systems, and land degradation. Simultaneously, unsustainable farming practices and poor 
      environmental management lead to soil erosion, water pollution, and biodiversity loss.

      The Irrigation and Environmental Management Programme (IEMP) aims to improve agricultural productivity and food 
      security through sustainable irrigation systems while protecting and restoring the environment. This integrated 
      approach aligns with the principles of Integrated Water Resources Management (IWRM) and supports national goals 
      for climate resilience, food security, and sustainable development.
    `,
  },
  {
    title: "Objectives",
    description: `
      To enhance agricultural productivity and livelihoods through sustainable irrigation development and sound 
      environmental management practices.
    `,
    objectives: [
      "To develop and rehabilitate small- and medium-scale irrigation schemes for efficient water use.",
      "To promote environmentally friendly land and water management practices.",
      "To strengthen the capacity of farmers and local institutions in irrigation system operation and maintenance.",
      "To mitigate environmental degradation through watershed protection and pollution control.",
      "To improve resilience to climate change through adaptive irrigation and soil conservation technologies.",
    ],
  },
];

export default IrrigationContent;
